import { useTabs } from '../store/context';

const useSpeakerPanelData = () => {
  const { globalTabsRef } = useTabs();

  const updateSpeakerPanelDemosInfoData = async (speakerPanelId: number) => {
    const speakerPanelData =
      await window.dsDesktop.speakerPanel.getData(speakerPanelId);
    await window.dsDesktop.speakerPanel.updateData(speakerPanelId, {
      activePresentationIndex: speakerPanelData.activePresentationIndex,
      demosInfo: speakerPanelData.demosInfo?.map((demo, index) => {
        const indexBasedGlobalTab = globalTabsRef.current.find(
          (tab) =>
            tab.group?.id === speakerPanelId &&
            tab.group?.mergingOptions?.index === index
        );

        const isDetached =
          indexBasedGlobalTab?.group?.mergingOptions?.isDetached;
        const isVisibleIfGroupIsInactive =
          indexBasedGlobalTab?.group?.isVisibleIfGroupIsInactive;

        return {
          ...demo,
          canDetach: !isDetached && !isVisibleIfGroupIsInactive,
        };
      }),
    });
  };

  return {
    updateSpeakerPanelDemosInfoData,
  };
};

export default useSpeakerPanelData;
